<template>
  <footer class="footer">
    <div class="page-footer">
      <FooterColumns v-if="theme === 'standard'" />
    </div>

    <div class="page-footer-lpg">
      <FooterBrand />
      <FooterCorporate />
    </div>
  </footer>
</template>

<script setup lang="ts">
import FooterCorporate from '~/components/footer/footer-corporate.vue';
import FooterBrand from '~/components/footer/footer-brand.vue';
import FooterColumns from '~/components/footer/footer-columns.vue';

export type PageFooterProps = {
  theme?: 'standard' | 'small';
};

withDefaults(defineProps<PageFooterProps>(), {
  theme: 'standard',
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.footer {
  position: relative;
}

.page-footer {
  background-color: var(--color-primary-fixed);
  color: var(--color-secondary-fixed);
  padding-top: 2 * $grid-base;

  @include mq($mq-md) {
    padding-top: 5 * $grid-base;
  }

  :deep(.shop-finder) {
    margin-top: $grid-medium-gutter;
  }
}

.page-footer-lpg {
  background-color: #262626;
  color: var(--color-secondary);

  @include hc() {
    background-color: var(--color-bg);
  }
}
</style>
